import axios from "axios";
import { API } from "../config/constants";

export const api = axios.create({
  baseURL: API.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//  Interceptor ensures token is always applied before every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    // console.log("Attaching token to request:", token);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
